import Image from 'next/image'
import Link from '@/components/ui/Link'

import { Icon } from '@/icons/Icon'
import { cn } from '@/lib/utils'

export default function PreferredSource({ invert = false }: { invert?: boolean }) {
  return (
    <Link
      href="http://efficient.link/preferred"
      target="_blank"
      passReferrerUrl={true}
      className={cn(
        'google-gradient-border group h-10 w-fit items-center gap-2.5 rounded-full border pl-1 pr-3 transition-colors duration-300 hover:border-transparent',
        invert
          ? 'hidden border-black/10 bg-white text-black md:flex'
          : 'flex border-white/15 bg-black text-white',
      )}
    >
      <div
        className={cn(
          'flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-white',
          invert ? 'border border-gray-300/20' : '',
        )}
      >
        <Image
          src="https://assets.efficient.app/google-logo-glyph.svg"
          alt="Google"
          width={22}
          height={22}
          className="saturate-0 transition-all group-hover:saturate-100"
        />
      </div>
      <span className="truncate text-15 font-semibold">Make us a preferred source</span>
      {!invert && <Icon name="heart" className="text-white" />}
    </Link>
  )
}
